var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"percentloop"},[_c('div',{staticClass:"circle-left",style:({
      backgroundColor: _vm.color
    })},[_c('div',{ref:"leftcontent"})]),_c('div',{staticClass:"circle-right",style:({
      backgroundColor: _vm.color
    })},[_c('div',{ref:"rightcontent"})]),_c('div',{staticClass:"number",style:({
      top: _vm.width + 'px',
      bottom: _vm.width + 'px',
      left: _vm.width + 'px',
      right: _vm.width + 'px',
      backgroundColor: _vm.backgroundColor
    })},[_c('div',[_c('i',{class:("iconfont icon-" + _vm.icon),style:({
          color: _vm.color,
          fontSize: _vm.fontSize
        })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }